// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PROSKINS Theme - Dark Theme CSS Framework */

/* CSS Variables for consistent theming */
:root {
  /* Primary Colors */
  --proskins-green: #3ad640;
  --proskins-green-dark: #00cc6a;
  --proskins-green-light: #33ff99;
  
  /* Background Colors */
  --bg-primary: #000000;
  --bg-secondary: #1a1a1a;
  --bg-tertiary: #2a2a2a;
  --bg-card: #1e1e1e;
  --bg-input: #2a2a2a;
  
  /* Text Colors */
  --text-primary: #ffffff;
  --text-secondary: #cccccc;
  --text-muted: #888888;
  --text-accent: var(--proskins-green);
  --text-required: #ff5555;

  /* Border Colors */
  --border-primary: #333333;
  --border-secondary: #444444;
  --border-accent: var(--proskins-green);
  
  /* Status Colors */
  --success: #3ad640;
  --error: #ff4444;
  --warning: #ffaa00;
  --info: #4488ff;

  /* Tier Colors */
  --tier-a: #fbbf24;
  --tier-b: #3b82f6;
  --tier-c: #f97316;
  --tier-d: #ef4444;
  
  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;
  
  /* Border Radius */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);
  --shadow-glow: 0 0 20px rgba(0, 255, 136, 0.3);
  
  /* Typography */
  --font-family: 'Poppins', sans-serif;
  --heading-font-family: 'Oswald', sans-serif;
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-2xl: 1.5rem;
  --font-size-3xl: 1.875rem;
  --font-size-4xl: 2.25rem;
  
  /* Transitions */
  --transition-fast: 0.15s ease-in-out;
  --transition-normal: 0.3s ease-in-out;
  --transition-slow: 0.5s ease-in-out;
}

/* Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.required-text {
  color: var(--text-required);
}

body {
  font-family: var(--font-family);
  background-color: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: var(--font-size-xs);
}

label.proskins-checkbox {
  display: flex;
  align-items: flex-start;
  font-family: var(--font-family);
  font-size: 11px;
  color: #fff;
  line-height: 1.5;
  text-align: left;
}

.admin-layout label.proskins-checkbox {
  color: #495057;
  font-size: 14px;
  margin-top: 20px;
}

label.proskins-checkbox input[type="checkbox"] {
  margin-right: 8px;
  margin-top: 2px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

label.proskins-checkbox input[type="checkbox"].input-error {
  outline: 1px solid var(--error);
  outline-offset: 1px;
  border-radius: 2px;
}

label.proskins-checkbox .required-text {
  font-size: 16px;
  margin-right: 4px;
}
.headingfont {
  font-family: var(--heading-font-family);
}
/* Layout Components */
.proskins-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.proskins-header {
  background-color: var(--bg-secondary);
  border-bottom: 1px solid var(--border-primary);
  padding: var(--spacing-md) 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.proskins-header-logo {
  flex: 0 0 auto;
}

.proskins-header-auth {
  flex: 0 0 auto;
}

.proskins-main {
  flex: 1 1;
  display: flex;
  min-height: calc(90vh - 80px);
  max-width : 1600px;
  margin: 0 auto;
  width: 100%;
}

.proskins-sidebar {
  width: 23rem;
  background-color: var(--bg-secondary);
  border-right: 1px solid var(--border-primary);
  padding: var(--spacing-lg);
  overflow-y: auto;
}

.proskins-sidebar-section .tier_a {
  color: #fbbf24;
}
.proskins-sidebar-section .tier_b {
  color: #3b82f6;
}
.proskins-sidebar-section .tier_c {
  color: #f97316;
}
.proskins-sidebar-section .tier_d {
  color: #ef4444;
}
.proskins-content {
  flex: 1 1;
  background-color: var(--bg-primary);
  /*padding: var(--spacing-lg);*/
  padding:10px;
  overflow-y: auto;
}

.proskins-rightbar {
  width: 27rem;
  background-color: var(--bg-secondary);
  border-left: 1px solid var(--border-primary);
  /*padding: var(--spacing-lg);*/
  overflow-y: auto;
}
.player_country{border-radius:50%;}
.rightside-title{padding: 1rem;}

/* PROSKINS Logo */
.proskins-logo {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  text-decoration: none;
  color: var(--text-primary);
}

.proskins-logo-icon {
  /* width: 160px;
  height: 160px; */
  background: transparent;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.proskins-logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.proskins-logo-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.proskins-logo-title {
  font-size: var(--font-size-xl);
  font-weight: 800;
  color: var(--proskins-green);
  text-shadow: 0 0 10px rgba(0, 255, 136, 0.3);
  letter-spacing: -0.02em;
}

.proskins-logo-tagline {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

/* Buttons */
.proskins-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  border: none;
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
  overflow: hidden;
}

.proskins-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.proskins-btn-primary {
  background: #3ad640;
  color: var(--bg-primary);
  box-shadow: var(--shadow-sm);
}

.proskins-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}

.proskins-btn-secondary {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-secondary);
}

.proskins-btn-secondary:hover:not(:disabled) {
  background-color: var(--bg-card);
  border-color: var(--border-accent);
}

.proskins-btn-outline {
  background-color: transparent;
  color: var(--proskins-green);
  border: 1px solid var(--proskins-green);
}

.proskins-btn-outline:hover:not(:disabled) {
  background-color: var(--proskins-green);
  color: var(--bg-primary);
}

.proskins-btn-large {
  padding: var(--spacing-md) var(--spacing-xl);
  font-size: var(--font-size-base);
}

.proskins-btn-small {
  padding: var(--spacing-xs) var(--spacing-md);
  font-size: var(--font-size-xs);
}

.proskins-btn-full {
  width: 100%;
}

/* Form Elements */
.proskins-input {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  background-color: var(--bg-input);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  transition: all var(--transition-fast);
}

.proskins-input:focus {
  outline: none;
  border-color: var(--proskins-green);
  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);
}

.proskins-input::placeholder {
  color: var(--text-muted);
}

.proskins-input-error {
  border-color: var(--error);
}

.proskins-input-error:focus {
  border-color: var(--error);
  box-shadow: 0 0 0 3px rgba(255, 68, 68, 0.1);
}

.proskins-label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-xs);
}

.proskins-form-group {
  margin-bottom: var(--spacing-lg);
}

.proskins-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-md);
}

.proskins-form-row-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--spacing-md);
}

/* Cards */
.proskins-card {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  padding: var(--spacing-xl);
  box-shadow: var(--shadow-md);
}

.proskins-card-header {
  margin-bottom: var(--spacing-lg);
}

.proskins-card-title {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--proskins-green);
  margin-bottom: var(--spacing-xs);
}

.proskins-card-subtitle {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

/* Alerts */
.proskins-alert {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-lg);
  font-size: var(--font-size-sm);
}

.proskins-alert-error {
  background-color: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.3);
  color: var(--error);
}

.proskins-alert-success {
  background-color: rgba(0, 255, 136, 0.1);
  border: 1px solid rgba(0, 255, 136, 0.3);
  color: var(--success);
}

.proskins-alert-warning {
  background-color: rgba(255, 170, 0, 0.1);
  border: 1px solid rgba(255, 170, 0, 0.3);
  color: var(--warning);
}

/* Navigation */
.proskins-nav {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.proskins-nav-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  transition: color var(--transition-fast);
  font-size: 1rem;
}

.proskins-nav-link:hover {
  color: var(--proskins-green);
}

.proskins-nav-link.active {
  color: var(--proskins-green);
}

/* Sidebar Sections */
.proskins-sidebar-section {
  margin-bottom: var(--spacing-xl);
}

.proskins-sidebar-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--proskins-green);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: var(--spacing-md);
}

.proskins-sidebar-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) 0;
  color: var(--text-secondary);
  text-decoration: none;
  transition: color var(--transition-fast);
  cursor: pointer;
  border-bottom: 1px solid var(--border-primary);
}

.proskins-sidebar-item:hover {
  color: var(--text-primary);
}

.proskins-sidebar-events {
  margin-left: var(--spacing-lg);
  margin-bottom: var(--spacing-md);
}

.proskins-sidebar-events ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.proskins-sidebar-events li {
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid var(--border-primary);
  margin: 0;
}

.proskins-sidebar-events li:last-child {
  border: none;
}

.proskins-sidebar-event:last-child {
  border-bottom: none;
}

.proskins-sidebar-event-date {
  font-size: var(--font-size-xs);
  color: var(--proskins-green);
  font-weight: 600;
  margin-bottom: var(--spacing-xs);
}

.proskins-sidebar-event-name, .proskins-sidebar-event-upcome-name {
  font-size: 0.95rem;
  color: var(--proskins-green);
  font-weight: 600;
  margin-bottom: var(--spacing-xs);
}
.proskins-sidebar-event-upcome-name {
  color: var(--text-muted);
}
.proskins-sidebar-event-subtitle {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  font-style: italic;
  margin-bottom: var(--spacing-xs);
}

.proskins-sidebar-event-location {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  line-height: 1.4;
}

/* Tables */
.proskins-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--bg-card);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.proskins-table th,
.proskins-table td {
  padding: var(--spacing-md);
  text-align: left;
  border-bottom: 1px solid var(--border-primary);
}

.proskins-table th {
  background-color: var(--bg-tertiary);
  font-weight: 600;
  color: var(--text-primary);
  font-size: var(--font-size-sm);
}

.proskins-table td {
  font-size: var(--font-size-xs);
}

.proskins-table tr:hover {
  background-color: var(--bg-tertiary);
}

/* Right sidebar specific table styles */
.proskins-rightbar .proskins-table {
  font-size: 0.85rem;
}

.proskins-rightbar .proskins-table th,
.proskins-rightbar .proskins-table td {
  padding: 0.5rem 0.75rem;
}

.proskins-rightbar .proskins-btn-small {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}

/* Utility Classes */
.proskins-text-center { text-align: center; }
.proskins-text-right { text-align: right; }
.proskins-text-left { text-align: left; }

.proskins-text-primary { color: var(--text-primary); }
.proskins-text-secondary { color: var(--text-secondary); }
.proskins-text-muted { color: var(--text-muted); }
.proskins-text-accent { color: var(--proskins-green); }

.proskins-bg-primary { background-color: var(--bg-primary); }
.proskins-bg-secondary { background-color: var(--bg-secondary); }
.proskins-bg-tertiary { background-color: var(--bg-tertiary); }

.proskins-mt-sm { margin-top: var(--spacing-sm); }
.proskins-mt-md { margin-top: var(--spacing-md); }
.proskins-mt-lg { margin-top: var(--spacing-lg); }
.proskins-mt-xl { margin-top: var(--spacing-xl); }

.proskins-mb-sm { margin-bottom: var(--spacing-sm); }
.proskins-mb-md { margin-bottom: var(--spacing-md); }
.proskins-mb-lg { margin-bottom: var(--spacing-lg); }
.proskins-mb-xl { margin-bottom: var(--spacing-xl); }

.proskins-p-sm { padding: var(--spacing-sm); }
.proskins-p-md { padding: var(--spacing-md); }
.proskins-p-lg { padding: var(--spacing-lg); }
.proskins-p-xl { padding: var(--spacing-xl); }

.proskins-flex { display: flex; }
.proskins-flex-col { flex-direction: column; }
.proskins-items-center { align-items: center; }
.proskins-justify-center { justify-content: center; }
.proskins-justify-between { justify-content: space-between; }
.proskins-gap-sm { gap: var(--spacing-sm); }
.proskins-gap-md { gap: var(--spacing-md); }
.proskins-gap-lg { gap: var(--spacing-lg); }

.proskins-hidden { display: none; }
.proskins-block { display: block; }
.proskins-inline-block { display: inline-block; }

/* Responsive Design */
@media (max-width: 1024px) {
  .proskins-sidebar,
  .proskins-rightbar {
    width: 250px;
  }
}

@media (max-width: 768px) {
  .proskins-main {
    flex-direction: column;
  }
  
  .proskins-sidebar,
  .proskins-rightbar {
    width: 100%;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid var(--border-primary);
  }
  
  .proskins-form-row,
  .proskins-form-row-3 {
    grid-template-columns: 1fr;
  }
  
  .proskins-nav {
    flex-direction: column;
    gap: var(--spacing-sm);
  }
  .header-content{
    display: block;
  }
  .proskins-header-logo {
    margin: 0 auto;
    padding-bottom: 10px;
  }
  .auth-buttons {
    margin: 0 auto;
    padding: 18px 10px;
    gap: 0.8rem;
  }
  .proskins-header .header-content .proskins-flex, .proskins-header .header-content .proskins-logo{
    display: block;
  }
  .proskins-logo-image{
    width: auto;
  }
}

@media (max-width: 480px) {
  .proskins-content,
  .proskins-sidebar,
  .proskins-rightbar {
    padding: var(--spacing-md);
  }
  
  .proskins-card {
    padding: var(--spacing-lg);
  }
  
  .proskins-btn-large {
    padding: var(--spacing-sm) var(--spacing-lg);
    font-size: var(--font-size-sm);
  }
}

/* Loading States */
.proskins-loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-secondary);
  border-radius: 50%;
  border-top-color: var(--proskins-green);
  animation: proskins-spin 1s ease-in-out infinite;
}

@keyframes proskins-spin {
  to { transform: rotate(360deg); }
}

/* Animations */
.proskins-fade-in {
  animation: proskins-fade-in 0.3s ease-in-out;
}

@keyframes proskins-fade-in {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.proskins-slide-in {
  animation: proskins-slide-in 0.3s ease-in-out;
}

@keyframes proskins-slide-in {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}

/* Golf Man Image Styles */
.proskins-sidebar-golfman {
  padding: var(--spacing-md);
  text-align: center;
  border-bottom: 1px solid var(--border-primary);
}

.proskins-golfman-image {
  width: 100%;
  max-width: 200px;
  height: auto;
  object-fit: contain;
  filter: brightness(0.9) contrast(1.1);
}

/* Search Bar Styles */
.proskins-sidebar-search {
  /*padding: var(--spacing-md);*/
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-primary);
}

.proskins-search-container {
  position: relative;
}

.proskins-search-input {
  width: 100%;
  /*padding: var(--spacing-md) var(--spacing-md) var(--spacing-md) var(--spacing-2xl);*/
  padding: 0.5rem;
  padding-left: 2.5rem;
  background-color: var(--bg-input);
  border: 1px solid var(--bg-input);
  color: var(--text-primary);
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  transition: all var(--transition-fast);
}

.proskins-search-input:focus {
  outline: none;
  border-color: var(--proskins-green);
  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);
}

.proskins-search-input::placeholder {
  color: var(--text-muted);
}

.proskins-search-icon {
  position: absolute;
  left: var(--spacing-md);
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}

/* Banner Styles */
.proskins-banner {
  border-radius: var(--radius-lg);
  padding: var(--spacing-2xl);
  margin-bottom: var(--spacing-lg);
  position: relative;
  overflow: hidden;
  min-height: 200px;
}

.proskins-banner-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.proskins-banner-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.proskins-banner-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-lg);
  min-height: 120px;
}

.proskins-banner-text {
  flex: 1 1;
  max-width: 80%;
  text-align: center;
}

.proskins-banner-title {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.3;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.proskins-banner-image {
  flex: 0 0 200px;
  height: 120px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.proskins-banner-golf-elements {
  position: relative;
  width: 100%;
  height: 100%;
}

.proskins-golf-ball {
  position: absolute;
  top: 20%;
  left: 20%;
  font-size: var(--font-size-2xl);
  animation: float 3s ease-in-out infinite;
}

.proskins-golf-tee {
  position: absolute;
  top: 50%;
  right: 30%;
  font-size: var(--font-size-2xl);
  animation: float 3s ease-in-out infinite 1s;
}

.proskins-golf-hand {
  position: absolute;
  bottom: 20%;
  left: 50%;
  font-size: var(--font-size-2xl);
  animation: float 3s ease-in-out infinite 2s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.proskins-banner-pagination {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  gap: var(--spacing-sm);
}

.proskins-pagination-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--border-secondary);
  transition: all var(--transition-fast);
}

.proskins-pagination-dot-active {
  background-color: var(--proskins-green);
  transform: scale(1.2);
}

/* Section Styles */
.proskins-section-title {
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--proskins-green);
  margin-bottom: var(--spacing-lg);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.proskins-subsection-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--spacing-sm);
}

.proskins-how-it-works {
  padding: var(--spacing-lg);
}

.proskins-how-it-works-content {
  max-width: 800px;
}

/* Player Tiers Styles */
.proskins-tiers-grid {
  display: grid;
  /*grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-lg);
  margin-top: var(--spacing-lg);*/
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.proskins-tier-card {
  background: var(--bg-secondary);
}

.proskins-tier-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.proskins-tier-icon {
  display: flex;
}

.proskins-tier-golf-elements {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.proskins-tier-image {
  width: 100%;
  height: 100%;
}

.proskins-tier-content {
  text-align: center;
}

.proskins-tier-title {
  font-size: var(--font-size-xl);
  font-weight: 700;
  margin-bottom: var(--spacing-sm);
  text-transform: uppercase;
}

.proskins-tier-description {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0;
}

/* Tier-specific colors */
.proskins-tier-a {
  border: 1px solid #fbbf24;
}

.proskins-tier-a-title {
  color: #fbbf24;
}

.proskins-tier-b {
  border: 1px solid #3b82f6;
}

.proskins-tier-b-title {
  color: #3b82f6;
}

.proskins-tier-c {
  border: 1px solid #f97316;
}

.proskins-tier-c-title {
  color: #f97316;
}

.proskins-tier-d {
  border: 1px solid #ef4444;
}

.proskins-tier-d-title {
  color: #ef4444;
}

/* Tier Badge Styles for Sidebar */
.tier-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  text-align: center;
  min-width: 60px;
}

.tier-badge.tier-a {
  background: #fbbf24;
  color: #000000;
}

.tier-badge.tier-b {
  background: #3b82f6;
  color: #ffffff;
}

.tier-badge.tier-c {
  background: #f97316;
  color: #ffffff;
}

.tier-badge.tier-d {
  background: #ef4444;
  color: #ffffff;
}

.tier-badge.tier-unassigned {
  background: #6b7280;
  color: #ffffff;
}
.golfers-proskins-main {
  padding: var(--spacing-lg);
  margin: 0 auto;
  min-height: 100vh;
}
.golfers-proskins-main .golfers-card{
  background: var(--bg-primary);
  border: 0;
  box-shadow: none;
}
.proskins-table table{
  width : 100%
}
.basicbg{
  background: var(--bg-secondary);
  padding: var(--spacing-lg);
}

/* Video Thumbnail */
/* Video Thumbnail */
.video-thumbnail {
  position: relative;
  cursor: pointer;
  margin-bottom: 1rem;
}

.video-image {
  width: 100%;
  border-radius: 8px;
  height: 180px;
  object-fit: cover;
}

/* Modal Styles */
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.video-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  aspect-ratio: 16 / 9; /* keeps video ratio responsive */
}

.video-iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
}

.close-button {
  position: absolute;
  top: 0px;
  right: 0;
  background-color: var(--proskins-green);
  color: var(--bg-primary);
  font-size: var(--font-size-lg);
  font-weight: bold;
  font-family: var(--font-family);
  line-height: 1.6;
  border: none;
  padding: 2px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

/* Play Button */
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 55px;
  height: 55px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.3s ease;
}

.play-button::before {
  content: "";
  display: block;
  margin-left: 5px;
  width: 0;
  height: 0;
  border-left: 20px solid white;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}

.play-button:hover {
  transform: translate(-50%, -50%) scale(1.1);
  background: rgba(255, 0, 0, 0.8); /* YouTube red on hover */
}

.input-error-text { color : rgba(255, 0, 0, 0.8); }
img.proskins-image {
  float : left;
  width: 30%;
  padding-right: var(--spacing-md);
}
img.proskins-right-image {
  float : right;
  width: 35%;
  padding-left: var(--spacing-md);
}

.about-image-container {
  max-width: 30%;
}
.about-content-container
{
  min-width: 70%;
}
.about-content-container p {
  padding: var(--spacing-xs);
  text-align: justify;
  font-size: 1rem;
}
.about-content-container h2 {
  margin-top: var(--spacing-lg);
}

/* Loader overlay */
.video-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
/* Loading Spinner - Global Utility */
.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.loading-spinner .spinner {
  width: 2rem;
  height: 2rem;
}

/* Spinner - Global Utility */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255,255,255,0.3);
  border-top: 5px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* -------------------- Responsive -------------------- */

/* Tablet */
@media (max-width: 1024px) {
  .video-container {
    max-width: 700px;
  }
  .play-button {
    font-size: 2.5rem;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .video-container {
    max-width: 100%;
  }
  .play-button {
    font-size: 2rem;
    padding: 8px 12px;
  }
}

/* Small Phones */
@media (max-width: 480px) {
  .video-container {
    aspect-ratio: 16 / 9;
    width: 100%;
  }
  .play-button {
    font-size: 1.5rem;
    padding: 6px 10px;
  }
}

/* Tournament Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-draft {
  background-color: #f3f4f6;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.status-active {
  background-color: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.status-live {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
  animation: pulse 2s infinite;
}

.status-completed {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}

.status-cancelled {
  background-color: #fee2e2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/proskins-theme.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C,yCAAyC;AACzC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;;EAE/B,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;;EAEnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;;EAExB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;;EAEtC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,YAAY;EACZ,yCAAyC;EACzC,yCAAyC;EACzC,2CAA2C;EAC3C,8CAA8C;;EAE9C,eAAe;EACf,oCAAoC;EACpC,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uCAAuC;AACzC;AACA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,6CAA6C;EAC7C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAO;EACP,mCAAmC;EACnC,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;AAClB;AACA,gBAAgB,iBAAiB,CAAC;AAClC,iBAAiB,aAAa,CAAC;;AAE/B,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE;kBACgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,4CAA4C;EAC5C,iCAAiC;EACjC,yCAAyC;EACzC,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB,wBAAwB,kBAAkB,EAAE;AAC5C,uBAAuB,iBAAiB,EAAE;AAC1C,sBAAsB,gBAAgB,EAAE;;AAExC,yBAAyB,0BAA0B,EAAE;AACrD,2BAA2B,4BAA4B,EAAE;AACzD,uBAAuB,wBAAwB,EAAE;AACjD,wBAAwB,4BAA4B,EAAE;;AAEtD,uBAAuB,mCAAmC,EAAE;AAC5D,yBAAyB,qCAAqC,EAAE;AAChE,wBAAwB,oCAAoC,EAAE;;AAE9D,kBAAkB,6BAA6B,EAAE;AACjD,kBAAkB,6BAA6B,EAAE;AACjD,kBAAkB,6BAA6B,EAAE;AACjD,kBAAkB,6BAA6B,EAAE;;AAEjD,kBAAkB,gCAAgC,EAAE;AACpD,kBAAkB,gCAAgC,EAAE;AACpD,kBAAkB,gCAAgC,EAAE;AACpD,kBAAkB,gCAAgC,EAAE;;AAEpD,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;;AAE7C,iBAAiB,aAAa,EAAE;AAChC,qBAAqB,sBAAsB,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE;AAC9C,2BAA2B,uBAAuB,EAAE;AACpD,4BAA4B,8BAA8B,EAAE;AAC5D,mBAAmB,sBAAsB,EAAE;AAC3C,mBAAmB,sBAAsB,EAAE;AAC3C,mBAAmB,sBAAsB,EAAE;;AAE3C,mBAAmB,aAAa,EAAE;AAClC,kBAAkB,cAAc,EAAE;AAClC,yBAAyB,qBAAqB,EAAE;;AAEhD,sBAAsB;AACtB;EACE;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,8CAA8C;EAChD;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4CAA4C;IAC5C,8BAA8B;EAChC;AACF;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,eAAe;AACf;EACE,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qFAAqF;EACrF,eAAe;EACf,oBAAoB;EACpB,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb;;iCAE+B;EAC/B,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;AACF;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB,oBAAoB;AACpB;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB,EAAE,iCAAiC;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,uCAAuC;EACvC,wBAAwB;EACxB,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC,EAAE,yBAAyB;AAC7D;;AAEA,oBAAoB,4BAA4B,EAAE;AAClD;EACE,YAAY;EACZ,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,yDAAyD;;AAEzD,WAAW;AACX;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* PROSKINS Theme - Dark Theme CSS Framework */\n\n/* CSS Variables for consistent theming */\n:root {\n  /* Primary Colors */\n  --proskins-green: #3ad640;\n  --proskins-green-dark: #00cc6a;\n  --proskins-green-light: #33ff99;\n  \n  /* Background Colors */\n  --bg-primary: #000000;\n  --bg-secondary: #1a1a1a;\n  --bg-tertiary: #2a2a2a;\n  --bg-card: #1e1e1e;\n  --bg-input: #2a2a2a;\n  \n  /* Text Colors */\n  --text-primary: #ffffff;\n  --text-secondary: #cccccc;\n  --text-muted: #888888;\n  --text-accent: var(--proskins-green);\n  --text-required: #ff5555;\n\n  /* Border Colors */\n  --border-primary: #333333;\n  --border-secondary: #444444;\n  --border-accent: var(--proskins-green);\n  \n  /* Status Colors */\n  --success: #3ad640;\n  --error: #ff4444;\n  --warning: #ffaa00;\n  --info: #4488ff;\n\n  /* Tier Colors */\n  --tier-a: #fbbf24;\n  --tier-b: #3b82f6;\n  --tier-c: #f97316;\n  --tier-d: #ef4444;\n  \n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-2xl: 3rem;\n  \n  /* Border Radius */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 16px;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);\n  --shadow-glow: 0 0 20px rgba(0, 255, 136, 0.3);\n  \n  /* Typography */\n  --font-family: 'Poppins', sans-serif;\n  --heading-font-family: 'Oswald', sans-serif;\n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-base: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.25rem;\n  --font-size-2xl: 1.5rem;\n  --font-size-3xl: 1.875rem;\n  --font-size-4xl: 2.25rem;\n  \n  /* Transitions */\n  --transition-fast: 0.15s ease-in-out;\n  --transition-normal: 0.3s ease-in-out;\n  --transition-slow: 0.5s ease-in-out;\n}\n\n/* Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.required-text {\n  color: var(--text-required);\n}\n\nbody {\n  font-family: var(--font-family);\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: var(--font-size-xs);\n}\n\nlabel.proskins-checkbox {\n  display: flex;\n  align-items: flex-start;\n  font-family: var(--font-family);\n  font-size: 11px;\n  color: #fff;\n  line-height: 1.5;\n  text-align: left;\n}\n\n.admin-layout label.proskins-checkbox {\n  color: #495057;\n  font-size: 14px;\n  margin-top: 20px;\n}\n\nlabel.proskins-checkbox input[type=\"checkbox\"] {\n  margin-right: 8px;\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\nlabel.proskins-checkbox input[type=\"checkbox\"].input-error {\n  outline: 1px solid var(--error);\n  outline-offset: 1px;\n  border-radius: 2px;\n}\n\nlabel.proskins-checkbox .required-text {\n  font-size: 16px;\n  margin-right: 4px;\n}\n.headingfont {\n  font-family: var(--heading-font-family);\n}\n/* Layout Components */\n.proskins-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.proskins-header {\n  background-color: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-primary);\n  padding: var(--spacing-md) 0;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.proskins-header-logo {\n  flex: 0 0 auto;\n}\n\n.proskins-header-auth {\n  flex: 0 0 auto;\n}\n\n.proskins-main {\n  flex: 1;\n  display: flex;\n  min-height: calc(90vh - 80px);\n  max-width : 1600px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.proskins-sidebar {\n  width: 23rem;\n  background-color: var(--bg-secondary);\n  border-right: 1px solid var(--border-primary);\n  padding: var(--spacing-lg);\n  overflow-y: auto;\n}\n\n.proskins-sidebar-section .tier_a {\n  color: #fbbf24;\n}\n.proskins-sidebar-section .tier_b {\n  color: #3b82f6;\n}\n.proskins-sidebar-section .tier_c {\n  color: #f97316;\n}\n.proskins-sidebar-section .tier_d {\n  color: #ef4444;\n}\n.proskins-content {\n  flex: 1;\n  background-color: var(--bg-primary);\n  /*padding: var(--spacing-lg);*/\n  padding:10px;\n  overflow-y: auto;\n}\n\n.proskins-rightbar {\n  width: 27rem;\n  background-color: var(--bg-secondary);\n  border-left: 1px solid var(--border-primary);\n  /*padding: var(--spacing-lg);*/\n  overflow-y: auto;\n}\n.player_country{border-radius:50%;}\n.rightside-title{padding: 1rem;}\n\n/* PROSKINS Logo */\n.proskins-logo {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  text-decoration: none;\n  color: var(--text-primary);\n}\n\n.proskins-logo-icon {\n  /* width: 160px;\n  height: 160px; */\n  background: transparent;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.proskins-logo-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.proskins-logo-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.proskins-logo-title {\n  font-size: var(--font-size-xl);\n  font-weight: 800;\n  color: var(--proskins-green);\n  text-shadow: 0 0 10px rgba(0, 255, 136, 0.3);\n  letter-spacing: -0.02em;\n}\n\n.proskins-logo-tagline {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  font-weight: 500;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n/* Buttons */\n.proskins-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border: none;\n  font-family: var(--font-family);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  position: relative;\n  overflow: hidden;\n}\n\n.proskins-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.proskins-btn-primary {\n  background: #3ad640;\n  color: var(--bg-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.proskins-btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-glow);\n}\n\n.proskins-btn-secondary {\n  background-color: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-secondary);\n}\n\n.proskins-btn-secondary:hover:not(:disabled) {\n  background-color: var(--bg-card);\n  border-color: var(--border-accent);\n}\n\n.proskins-btn-outline {\n  background-color: transparent;\n  color: var(--proskins-green);\n  border: 1px solid var(--proskins-green);\n}\n\n.proskins-btn-outline:hover:not(:disabled) {\n  background-color: var(--proskins-green);\n  color: var(--bg-primary);\n}\n\n.proskins-btn-large {\n  padding: var(--spacing-md) var(--spacing-xl);\n  font-size: var(--font-size-base);\n}\n\n.proskins-btn-small {\n  padding: var(--spacing-xs) var(--spacing-md);\n  font-size: var(--font-size-xs);\n}\n\n.proskins-btn-full {\n  width: 100%;\n}\n\n/* Form Elements */\n.proskins-input {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background-color: var(--bg-input);\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-family: var(--font-family);\n  font-size: var(--font-size-sm);\n  transition: all var(--transition-fast);\n}\n\n.proskins-input:focus {\n  outline: none;\n  border-color: var(--proskins-green);\n  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);\n}\n\n.proskins-input::placeholder {\n  color: var(--text-muted);\n}\n\n.proskins-input-error {\n  border-color: var(--error);\n}\n\n.proskins-input-error:focus {\n  border-color: var(--error);\n  box-shadow: 0 0 0 3px rgba(255, 68, 68, 0.1);\n}\n\n.proskins-label {\n  display: block;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-xs);\n}\n\n.proskins-form-group {\n  margin-bottom: var(--spacing-lg);\n}\n\n.proskins-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-md);\n}\n\n.proskins-form-row-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: var(--spacing-md);\n}\n\n/* Cards */\n.proskins-card {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-xl);\n  box-shadow: var(--shadow-md);\n}\n\n.proskins-card-header {\n  margin-bottom: var(--spacing-lg);\n}\n\n.proskins-card-title {\n  font-size: var(--font-size-2xl);\n  font-weight: 700;\n  color: var(--proskins-green);\n  margin-bottom: var(--spacing-xs);\n}\n\n.proskins-card-subtitle {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n/* Alerts */\n.proskins-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-md);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--spacing-lg);\n  font-size: var(--font-size-sm);\n}\n\n.proskins-alert-error {\n  background-color: rgba(255, 68, 68, 0.1);\n  border: 1px solid rgba(255, 68, 68, 0.3);\n  color: var(--error);\n}\n\n.proskins-alert-success {\n  background-color: rgba(0, 255, 136, 0.1);\n  border: 1px solid rgba(0, 255, 136, 0.3);\n  color: var(--success);\n}\n\n.proskins-alert-warning {\n  background-color: rgba(255, 170, 0, 0.1);\n  border: 1px solid rgba(255, 170, 0, 0.3);\n  color: var(--warning);\n}\n\n/* Navigation */\n.proskins-nav {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n}\n\n.proskins-nav-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color var(--transition-fast);\n  font-size: 1rem;\n}\n\n.proskins-nav-link:hover {\n  color: var(--proskins-green);\n}\n\n.proskins-nav-link.active {\n  color: var(--proskins-green);\n}\n\n/* Sidebar Sections */\n.proskins-sidebar-section {\n  margin-bottom: var(--spacing-xl);\n}\n\n.proskins-sidebar-title {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--proskins-green);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: var(--spacing-md);\n}\n\n.proskins-sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) 0;\n  color: var(--text-secondary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n  cursor: pointer;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.proskins-sidebar-item:hover {\n  color: var(--text-primary);\n}\n\n.proskins-sidebar-events {\n  margin-left: var(--spacing-lg);\n  margin-bottom: var(--spacing-md);\n}\n\n.proskins-sidebar-events ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.proskins-sidebar-events li {\n  padding: var(--spacing-sm) 0;\n  border-bottom: 1px solid var(--border-primary);\n  margin: 0;\n}\n\n.proskins-sidebar-events li:last-child {\n  border: none;\n}\n\n.proskins-sidebar-event:last-child {\n  border-bottom: none;\n}\n\n.proskins-sidebar-event-date {\n  font-size: var(--font-size-xs);\n  color: var(--proskins-green);\n  font-weight: 600;\n  margin-bottom: var(--spacing-xs);\n}\n\n.proskins-sidebar-event-name, .proskins-sidebar-event-upcome-name {\n  font-size: 0.95rem;\n  color: var(--proskins-green);\n  font-weight: 600;\n  margin-bottom: var(--spacing-xs);\n}\n.proskins-sidebar-event-upcome-name {\n  color: var(--text-muted);\n}\n.proskins-sidebar-event-subtitle {\n  font-size: var(--font-size-xs);\n  color: var(--text-muted);\n  font-style: italic;\n  margin-bottom: var(--spacing-xs);\n}\n\n.proskins-sidebar-event-location {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n/* Tables */\n.proskins-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: var(--bg-card);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n\n.proskins-table th,\n.proskins-table td {\n  padding: var(--spacing-md);\n  text-align: left;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.proskins-table th {\n  background-color: var(--bg-tertiary);\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: var(--font-size-sm);\n}\n\n.proskins-table td {\n  font-size: var(--font-size-xs);\n}\n\n.proskins-table tr:hover {\n  background-color: var(--bg-tertiary);\n}\n\n/* Right sidebar specific table styles */\n.proskins-rightbar .proskins-table {\n  font-size: 0.85rem;\n}\n\n.proskins-rightbar .proskins-table th,\n.proskins-rightbar .proskins-table td {\n  padding: 0.5rem 0.75rem;\n}\n\n.proskins-rightbar .proskins-btn-small {\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  white-space: nowrap;\n}\n\n/* Utility Classes */\n.proskins-text-center { text-align: center; }\n.proskins-text-right { text-align: right; }\n.proskins-text-left { text-align: left; }\n\n.proskins-text-primary { color: var(--text-primary); }\n.proskins-text-secondary { color: var(--text-secondary); }\n.proskins-text-muted { color: var(--text-muted); }\n.proskins-text-accent { color: var(--proskins-green); }\n\n.proskins-bg-primary { background-color: var(--bg-primary); }\n.proskins-bg-secondary { background-color: var(--bg-secondary); }\n.proskins-bg-tertiary { background-color: var(--bg-tertiary); }\n\n.proskins-mt-sm { margin-top: var(--spacing-sm); }\n.proskins-mt-md { margin-top: var(--spacing-md); }\n.proskins-mt-lg { margin-top: var(--spacing-lg); }\n.proskins-mt-xl { margin-top: var(--spacing-xl); }\n\n.proskins-mb-sm { margin-bottom: var(--spacing-sm); }\n.proskins-mb-md { margin-bottom: var(--spacing-md); }\n.proskins-mb-lg { margin-bottom: var(--spacing-lg); }\n.proskins-mb-xl { margin-bottom: var(--spacing-xl); }\n\n.proskins-p-sm { padding: var(--spacing-sm); }\n.proskins-p-md { padding: var(--spacing-md); }\n.proskins-p-lg { padding: var(--spacing-lg); }\n.proskins-p-xl { padding: var(--spacing-xl); }\n\n.proskins-flex { display: flex; }\n.proskins-flex-col { flex-direction: column; }\n.proskins-items-center { align-items: center; }\n.proskins-justify-center { justify-content: center; }\n.proskins-justify-between { justify-content: space-between; }\n.proskins-gap-sm { gap: var(--spacing-sm); }\n.proskins-gap-md { gap: var(--spacing-md); }\n.proskins-gap-lg { gap: var(--spacing-lg); }\n\n.proskins-hidden { display: none; }\n.proskins-block { display: block; }\n.proskins-inline-block { display: inline-block; }\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .proskins-sidebar,\n  .proskins-rightbar {\n    width: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .proskins-main {\n    flex-direction: column;\n  }\n  \n  .proskins-sidebar,\n  .proskins-rightbar {\n    width: 100%;\n    border-right: none;\n    border-left: none;\n    border-bottom: 1px solid var(--border-primary);\n  }\n  \n  .proskins-form-row,\n  .proskins-form-row-3 {\n    grid-template-columns: 1fr;\n  }\n  \n  .proskins-nav {\n    flex-direction: column;\n    gap: var(--spacing-sm);\n  }\n  .header-content{\n    display: block;\n  }\n  .proskins-header-logo {\n    margin: 0 auto;\n    padding-bottom: 10px;\n  }\n  .auth-buttons {\n    margin: 0 auto;\n    padding: 18px 10px;\n    gap: 0.8rem;\n  }\n  .proskins-header .header-content .proskins-flex, .proskins-header .header-content .proskins-logo{\n    display: block;\n  }\n  .proskins-logo-image{\n    width: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .proskins-content,\n  .proskins-sidebar,\n  .proskins-rightbar {\n    padding: var(--spacing-md);\n  }\n  \n  .proskins-card {\n    padding: var(--spacing-lg);\n  }\n  \n  .proskins-btn-large {\n    padding: var(--spacing-sm) var(--spacing-lg);\n    font-size: var(--font-size-sm);\n  }\n}\n\n/* Loading States */\n.proskins-loading {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--border-secondary);\n  border-radius: 50%;\n  border-top-color: var(--proskins-green);\n  animation: proskins-spin 1s ease-in-out infinite;\n}\n\n@keyframes proskins-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Animations */\n.proskins-fade-in {\n  animation: proskins-fade-in 0.3s ease-in-out;\n}\n\n@keyframes proskins-fade-in {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.proskins-slide-in {\n  animation: proskins-slide-in 0.3s ease-in-out;\n}\n\n@keyframes proskins-slide-in {\n  from { opacity: 0; transform: translateX(-20px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n/* Golf Man Image Styles */\n.proskins-sidebar-golfman {\n  padding: var(--spacing-md);\n  text-align: center;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.proskins-golfman-image {\n  width: 100%;\n  max-width: 200px;\n  height: auto;\n  object-fit: contain;\n  filter: brightness(0.9) contrast(1.1);\n}\n\n/* Search Bar Styles */\n.proskins-sidebar-search {\n  /*padding: var(--spacing-md);*/\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.proskins-search-container {\n  position: relative;\n}\n\n.proskins-search-input {\n  width: 100%;\n  /*padding: var(--spacing-md) var(--spacing-md) var(--spacing-md) var(--spacing-2xl);*/\n  padding: 0.5rem;\n  padding-left: 2.5rem;\n  background-color: var(--bg-input);\n  border: 1px solid var(--bg-input);\n  color: var(--text-primary);\n  font-family: var(--font-family);\n  font-size: var(--font-size-sm);\n  transition: all var(--transition-fast);\n}\n\n.proskins-search-input:focus {\n  outline: none;\n  border-color: var(--proskins-green);\n  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);\n}\n\n.proskins-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.proskins-search-icon {\n  position: absolute;\n  left: var(--spacing-md);\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  font-size: var(--font-size-sm);\n}\n\n/* Banner Styles */\n.proskins-banner {\n  border-radius: var(--radius-lg);\n  padding: var(--spacing-2xl);\n  margin-bottom: var(--spacing-lg);\n  position: relative;\n  overflow: hidden;\n  min-height: 200px;\n}\n\n.proskins-banner-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n}\n\n.proskins-banner-bg-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.proskins-banner-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-lg);\n  min-height: 120px;\n}\n\n.proskins-banner-text {\n  flex: 1;\n  max-width: 80%;\n  text-align: center;\n}\n\n.proskins-banner-title {\n  font-size: var(--font-size-2xl);\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.3;\n  margin: 0;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n}\n\n.proskins-banner-image {\n  flex: 0 0 200px;\n  height: 120px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.proskins-banner-golf-elements {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.proskins-golf-ball {\n  position: absolute;\n  top: 20%;\n  left: 20%;\n  font-size: var(--font-size-2xl);\n  animation: float 3s ease-in-out infinite;\n}\n\n.proskins-golf-tee {\n  position: absolute;\n  top: 50%;\n  right: 30%;\n  font-size: var(--font-size-2xl);\n  animation: float 3s ease-in-out infinite 1s;\n}\n\n.proskins-golf-hand {\n  position: absolute;\n  bottom: 20%;\n  left: 50%;\n  font-size: var(--font-size-2xl);\n  animation: float 3s ease-in-out infinite 2s;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n}\n\n.proskins-banner-pagination {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-sm);\n}\n\n.proskins-pagination-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--border-secondary);\n  transition: all var(--transition-fast);\n}\n\n.proskins-pagination-dot-active {\n  background-color: var(--proskins-green);\n  transform: scale(1.2);\n}\n\n/* Section Styles */\n.proskins-section-title {\n  font-size: var(--font-size-xl);\n  font-weight: 700;\n  color: var(--proskins-green);\n  margin-bottom: var(--spacing-lg);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.proskins-subsection-title {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.proskins-how-it-works {\n  padding: var(--spacing-lg);\n}\n\n.proskins-how-it-works-content {\n  max-width: 800px;\n}\n\n/* Player Tiers Styles */\n.proskins-tiers-grid {\n  display: grid;\n  /*grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--spacing-lg);\n  margin-top: var(--spacing-lg);*/\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.proskins-tier-card {\n  background: var(--bg-secondary);\n}\n\n.proskins-tier-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.proskins-tier-icon {\n  display: flex;\n}\n\n.proskins-tier-golf-elements {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.proskins-tier-image {\n  width: 100%;\n  height: 100%;\n}\n\n.proskins-tier-content {\n  text-align: center;\n}\n\n.proskins-tier-title {\n  font-size: var(--font-size-xl);\n  font-weight: 700;\n  margin-bottom: var(--spacing-sm);\n  text-transform: uppercase;\n}\n\n.proskins-tier-description {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Tier-specific colors */\n.proskins-tier-a {\n  border: 1px solid #fbbf24;\n}\n\n.proskins-tier-a-title {\n  color: #fbbf24;\n}\n\n.proskins-tier-b {\n  border: 1px solid #3b82f6;\n}\n\n.proskins-tier-b-title {\n  color: #3b82f6;\n}\n\n.proskins-tier-c {\n  border: 1px solid #f97316;\n}\n\n.proskins-tier-c-title {\n  color: #f97316;\n}\n\n.proskins-tier-d {\n  border: 1px solid #ef4444;\n}\n\n.proskins-tier-d-title {\n  color: #ef4444;\n}\n\n/* Tier Badge Styles for Sidebar */\n.tier-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  white-space: nowrap;\n  text-align: center;\n  min-width: 60px;\n}\n\n.tier-badge.tier-a {\n  background: #fbbf24;\n  color: #000000;\n}\n\n.tier-badge.tier-b {\n  background: #3b82f6;\n  color: #ffffff;\n}\n\n.tier-badge.tier-c {\n  background: #f97316;\n  color: #ffffff;\n}\n\n.tier-badge.tier-d {\n  background: #ef4444;\n  color: #ffffff;\n}\n\n.tier-badge.tier-unassigned {\n  background: #6b7280;\n  color: #ffffff;\n}\n.golfers-proskins-main {\n  padding: var(--spacing-lg);\n  margin: 0 auto;\n  min-height: 100vh;\n}\n.golfers-proskins-main .golfers-card{\n  background: var(--bg-primary);\n  border: 0;\n  box-shadow: none;\n}\n.proskins-table table{\n  width : 100%\n}\n.basicbg{\n  background: var(--bg-secondary);\n  padding: var(--spacing-lg);\n}\n\n/* Video Thumbnail */\n/* Video Thumbnail */\n.video-thumbnail {\n  position: relative;\n  cursor: pointer;\n  margin-bottom: 1rem;\n}\n\n.video-image {\n  width: 100%;\n  border-radius: 8px;\n  height: 180px;\n  object-fit: cover;\n}\n\n/* Modal Styles */\n.video-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  max-width: 800px;\n  aspect-ratio: 16 / 9; /* keeps video ratio responsive */\n}\n\n.video-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 8px;\n}\n\n.close-button {\n  position: absolute;\n  top: 0px;\n  right: 0;\n  background-color: var(--proskins-green);\n  color: var(--bg-primary);\n  font-size: var(--font-size-lg);\n  font-weight: bold;\n  font-family: var(--font-family);\n  line-height: 1.6;\n  border: none;\n  padding: 2px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n/* Play Button */\n.play-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 55px;\n  height: 55px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.2s ease, background 0.3s ease;\n}\n\n.play-button::before {\n  content: \"\";\n  display: block;\n  margin-left: 5px;\n  width: 0;\n  height: 0;\n  border-left: 20px solid white;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n}\n\n.play-button:hover {\n  transform: translate(-50%, -50%) scale(1.1);\n  background: rgba(255, 0, 0, 0.8); /* YouTube red on hover */\n}\n\n.input-error-text { color : rgba(255, 0, 0, 0.8); }\nimg.proskins-image {\n  float : left;\n  width: 30%;\n  padding-right: var(--spacing-md);\n}\nimg.proskins-right-image {\n  float : right;\n  width: 35%;\n  padding-left: var(--spacing-md);\n}\n\n.about-image-container {\n  max-width: 30%;\n}\n.about-content-container\n{\n  min-width: 70%;\n}\n.about-content-container p {\n  padding: var(--spacing-xs);\n  text-align: justify;\n  font-size: 1rem;\n}\n.about-content-container h2 {\n  margin-top: var(--spacing-lg);\n}\n\n/* Loader overlay */\n.video-loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n/* Loading Spinner - Global Utility */\n.loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.loading-spinner .spinner {\n  width: 2rem;\n  height: 2rem;\n}\n\n/* Spinner - Global Utility */\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(255,255,255,0.3);\n  border-top: 5px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* -------------------- Responsive -------------------- */\n\n/* Tablet */\n@media (max-width: 1024px) {\n  .video-container {\n    max-width: 700px;\n  }\n  .play-button {\n    font-size: 2.5rem;\n  }\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .video-container {\n    max-width: 100%;\n  }\n  .play-button {\n    font-size: 2rem;\n    padding: 8px 12px;\n  }\n}\n\n/* Small Phones */\n@media (max-width: 480px) {\n  .video-container {\n    aspect-ratio: 16 / 9;\n    width: 100%;\n  }\n  .play-button {\n    font-size: 1.5rem;\n    padding: 6px 10px;\n  }\n}\n\n/* Tournament Status Badges */\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-draft {\n  background-color: #f3f4f6;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.status-active {\n  background-color: #dcfce7;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.status-live {\n  background-color: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fde68a;\n  animation: pulse 2s infinite;\n}\n\n.status-completed {\n  background-color: #dbeafe;\n  color: #1e40af;\n  border: 1px solid #bfdbfe;\n}\n\n.status-cancelled {\n  background-color: #fee2e2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
